import { Component } from '@angular/core'
import { environment } from '@tv3/environments/environment'

@Component({
  selector: 'app-login-layout',
  templateUrl: './login-layout.component.html',
  styleUrls: ['./login-layout.component.scss'],
})
export class LoginLayoutComponent {
  advanceCmUrl = `${environment.acmAppUrl}/en/login?utm_source=site&utm_medium=organic&utm_campaign=loginpage`
}
